module.exports = __webpack_public_path__ + "img/Group.df1d415.svg";